import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getLoggedUserData, hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import UserSignupLinkCreateDrawer from "@/components/user/UserSignupLinkCreateDrawer.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "adminUserSignupLinkList",
  components: {
    confirm: confirmationComponent,
    UserSignupLinkCreateDrawer: UserSignupLinkCreateDrawer,
    ErrorModal: ErrorModal
  },
  data: function data() {
    return {
      loggedUserData: {},
      currentLink: {},
      links: [],
      numberOfLinks: 0,
      showCreateDrawer: false,
      editingLinkId: null,
      editingName: "",
      isSavingEdit: false,
      editingUtmLinkId: null,
      editingUtmSource: "",
      loadings: {
        datatable: false
      },
      headers: [{
        text: "Name",
        value: "name"
      }, {
        text: "UTM Source",
        value: "utmSource"
      }, {
        text: "Link",
        value: "link"
      }, {
        text: "Used times",
        value: "usedNumber"
      }, {
        text: "Created at",
        value: "createdAt"
      }, {
        text: "Created by",
        value: "createdBy"
      }, {
        text: "Actions",
        value: "actions",
        sortable: false
      }],
      cancellationToken: null,
      editCancellationToken: null,
      isCopyingToClipboard: false,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    canManage: function canManage() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.loggedUserData = getLoggedUserData();
            _this2.getSignupLinks();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getSignupLinks: function getSignupLinks() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this$cancellationTok;
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _this.loadings.datatable = true;
              (_this$cancellationTok = _this.cancellationToken) === null || _this$cancellationTok === void 0 || _this$cancellationTok.cancel();
              _this.cancellationToken = axios.CancelToken.source();
              _context2.next = 6;
              return request("/v1/users/signup-link", "get", null, true, "api", null, _this.cancellationToken.token).then(function (response) {
                _this.loadings.datatable = false;
                _this.links = response.data.value;
                _this.links.forEach(function (item) {
                  item.link = "".concat(window.location.origin, "/subscribe?utm_source=").concat(item.utmSource);
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load sign up links.", true);
                handleErrorData(_this, errorData);
                _this.loadings.datatable = false;
                throw e;
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    goToUserPage: function goToUserPage(user) {
      return {
        name: "adminUserDetails",
        query: {
          id_user: user.id_user,
          fromList: true
        }
      };
    },
    addNewLink: function addNewLink() {
      this.showCreateDrawer = true;
    },
    onLinkCreated: function onLinkCreated() {
      this.getSignupLinks();
    },
    isEditing: function isEditing(item) {
      return this.editingLinkId === item.id;
    },
    startEdit: function startEdit(item) {
      this.editingLinkId = item.id;
      this.editingName = item.name;
    },
    cancelEdit: function cancelEdit() {
      this.editingLinkId = null;
      this.editingName = "";
    },
    isEditingUtm: function isEditingUtm(item) {
      return this.editingUtmLinkId === item.id;
    },
    startUtmEdit: function startUtmEdit(item) {
      this.editingUtmLinkId = item.id;
      this.editingUtmSource = item.utmSource;
    },
    cancelUtmEdit: function cancelUtmEdit() {
      this.editingUtmLinkId = null;
      this.editingUtmSource = "";
    },
    sanitizeUtmSource: function sanitizeUtmSource(value) {
      this.editingUtmSource = value.toLowerCase().replace(/\s+/g, "_");
    },
    saveEdit: function saveEdit(item, field) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$editCancellatio;
        var isUtm, value, trimmedValue, _this, payload;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isUtm = field === "utmSource";
              value = isUtm ? _this4.editingUtmSource : _this4.editingName;
              trimmedValue = value === null || value === void 0 ? void 0 : value.trim();
              if (trimmedValue) {
                _context3.next = 6;
                break;
              }
              _this4.$toasted.show(isUtm ? "UTM Source is required" : "Name is required", {
                type: "error"
              });
              return _context3.abrupt("return");
            case 6:
              if (!(trimmedValue === item[field])) {
                _context3.next = 9;
                break;
              }
              isUtm ? _this4.cancelUtmEdit() : _this4.cancelEdit();
              return _context3.abrupt("return");
            case 9:
              if (!_this4.isSavingEdit) {
                _context3.next = 11;
                break;
              }
              return _context3.abrupt("return");
            case 11:
              _this = _this4;
              _this.isSavingEdit = true;
              (_this$editCancellatio = _this.editCancellationToken) === null || _this$editCancellatio === void 0 || _this$editCancellatio.cancel();
              _this.editCancellationToken = axios.CancelToken.source();
              payload = {
                id: item.id,
                name: isUtm ? item.name : trimmedValue,
                utmSource: isUtm ? trimmedValue : item.utmSource
              };
              _context3.next = 18;
              return request("/v1/users/signup-link", "put", payload, true, "api", null, _this.editCancellationToken.token).then(function () {
                _this.isSavingEdit = false;
                item[field] = trimmedValue;
                if (isUtm) {
                  item.link = "".concat(window.location.origin, "/subscribe?utm_source=").concat(trimmedValue);
                }
                _this.$toasted.show("Sign up link updated", {
                  type: "success"
                });
                isUtm ? _this.cancelUtmEdit() : _this.cancelEdit();
              }).catch(function (e) {
                _this.isSavingEdit = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save sign up link.", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    deleteItem: function deleteItem(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$cancellationTok2;
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.$refs.confirm.open("Delete sign up link", "Are you sure you want to delete this sign up link? This action cannot be undone.");
            case 2:
              confirmed = _context4.sent;
              if (confirmed) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return");
            case 5:
              _this = _this5;
              (_this$cancellationTok2 = _this.cancellationToken) === null || _this$cancellationTok2 === void 0 || _this$cancellationTok2.cancel();
              _this.cancellationToken = axios.CancelToken.source();
              _context4.next = 10;
              return request("/v1/users/signup-link/".concat(item.id), "delete", null, true, "api", null, _this.cancellationToken.token).then(function () {
                _this.$toasted.show("Sign up link deleted", {
                  type: "success"
                });
                _this.getSignupLinks();
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete sign up link", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    hasUsed: function hasUsed(link) {
      return link.usedNumber > 0;
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this6 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this6.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    },
    isAdminNotConsultant: isAdminNotConsultant,
    hasRole: hasRole
  }
};